import {GetMessageCodeText} from "../app-components/outputs/MessageCodes";
import React from "react";
import {Button, Popover} from "antd";
import {ToolOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {AppActions, useAppContext} from "../context/AppContext";
import {getFixByErrorId} from "../app-components/run-project/fix/fixRegistry";
import {useUser} from "../context/UserContext";
import {ACCESS_MODULES, getPermissionSet, hasPermission} from "../helpers/PermissionHelper";

export default function ResultView({message_key, error_id, headerExtra, children}) {
    // Registry'de bu error_id icin bir fix varsa, header'a otomatik Fix butonu
    // gelir — her mesaj komponentini ayrica degistirmeye gerek yok.
    const fixDef = getFixByErrorId(error_id);

    return (
        <>
            <div
                style={{
                    marginTop: 4,
                    marginBottom: 4,
                    fontFamily: 'Segoe ui',
                    fontSize: '9pt',
                    backgroundColor: '#f0f2f5',
                    paddingLeft: 8,
                    paddingRight: 4,
                    paddingTop: '1mm',
                    paddingBottom: '1mm',
                    textAlign: 'start',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                <b>Message Code: {GetMessageCodeText(message_key, error_id)}</b>
                {fixDef && <FixHeaderButton fixDef={fixDef}/>}
                {headerExtra}
            </div>
            <div style={{paddingLeft: 8}}>
                {children}
            </div>
        </>
    )
}

// Mesaj kodu yaninda: fix bilgisi popover'i + Fix sayfasina yonlendirme.
const FixHeaderButton = ({fixDef}) => {
    const history = useHistory();
    const {appContext, dispatchProject, selectedHistoryId} = useAppContext();
    const {user} = useUser();

    // Fix Module izni olmayan kullaniciya yonlendirme butonu gosterilmez.
    const canFix = hasPermission(getPermissionSet(user), ACCESS_MODULES.RUN_FIX);
    if (!canFix) return null;

    const goToFix = () => {
        // Goruntulenen geçmişin secimini Fix sayfasina tasi ki dogru planin
        // Check sonucu yuklensin.
        const hist = appContext?.history?.find(x => x.id === selectedHistoryId);
        if (hist?.selection?.base) {
            dispatchProject({
                type: AppActions.SET_PROJECT_SELECTION,
                data: {selection: {base: {...hist.selection.base}, compare: {}}},
            });
        }
        history.push('/app/run', {tab: 'fix-module', fixId: fixDef.id});
    };

    return (
        <Popover
            placement="bottomLeft"
            trigger="click"
            content={(
                <div style={{maxWidth: 320}}>
                    <div style={{fontWeight: 600, marginBottom: 4}}>{fixDef.label} ({fixDef.error_id})</div>
                    <div style={{fontSize: 12, color: '#555', marginBottom: 10}}>{fixDef.info}</div>
                    <Button size="small" type="primary" icon={<ToolOutlined/>} onClick={goToFix}>
                        Go to Fix
                    </Button>
                </div>
            )}
        >
            <Button size="small" type="primary" ghost icon={<ToolOutlined/>}>Fix</Button>
        </Popover>
    );
};
